import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { pageUp, pageDown, currentPage, set_ep1_lastVisitFrame } from '../../../Redux/Slices/generalSlice';
import { setLanguageEnglish, setLanguageUrdu, currentLanguage } from '../../../Redux/Slices/languageSlice';
import './F7.css';
import backIcon2 from '../../../Assests/backIcon2.svg'

function Frame7() {
    let [isLoading, setIsLoading] = useState(false);
    let dispatch = useDispatch();
    let pageNo = useSelector(currentPage);
    let language = useSelector(currentLanguage);
    useEffect(() => {
        setTimeout(function () { setIsLoading(false) }, 100);

    }, []);

    if (isLoading === true) {
        return (<div className="F6_image"></div>)
    } else {
        return (
            <div className="F7_imageAnimate">
                <img onClick={() => { dispatch(pageDown()) }} className='backButton' src={backIcon2} alt="React Logo" height={30} />
                <div className="F7_entryBox">
                    <div className="F7_paragraph">
                        {language === 'english' ?
                            <p className="F7_paragraphEnglish">Locked in her room, Saira is hesitant to talk to her mother. She just recalls her friend Maria had told her that when she mentioned similar experience to her mother, her mother discouraged her to talk about it with anyone and asked her to keep it a secret. This gives Saira the impression that it is very shameful.</p>
                            :
                            <p className="F7_paragraphUrdu">سائرا اس وقت اپنے کمرے میں بند ہے اور وہ اپنی امی سے بات کرنے سے ہچکچا رہی ہے۔ اس کو یہ یاد کرکے پریشانی ہو رہی ہے کہ اس کی دوست ماریہ نے جب اپنی امی کو اپنی پہلی ماہواری کے بارے میں بتایا تھا تو انہوں نے اسے اس بارے میں کسی سے بات کرنے سے روکا تھا۔ اور اسے یہ تنبیہ کی تھی کہ اسے راز میں رکھا جائے جس سے سائرا کو یہ تاثر ملا کہ یہ نہایت شرم کی بات ہے۔</p>
                        }
                    </div>
                    <div className="F7_timeline">
                        <div className='F7_timelineBar'>
                            <div className='F7_timelineFill'></div>
                            <span className='F7_timelineText'>6/16</span>
                        </div>
                    </div>

                    <div className="F7_nextFrames">
                        <div className="F7_nextFrame1"></div>
                        <div className="F7_nextFrame2"></div>
                        <div className="F7_nextFrame3"></div>
                    </div>

                    <div className='F7_buttonDiv'>
                        <button onClick={() => { dispatch(pageUp()); dispatch(set_ep1_lastVisitFrame(6)) }} className='F7_button'>
                            {language === 'english' ? 'Continue' : 'آگے  جائیں'}
                        </button>
                    </div>

                </div>
            </div>
        )
    }
}

export default Frame7;